module.exports = __webpack_public_path__ + "img/ESG_aloldalhoz_grafikak_04.60611b9d.jpg";